import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';

import Navbar from './components/Navbar';
import WhatsAppButton from './components/WaButton';
import BackToTop from './components/BackToTop';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';

const Sobre = lazy(() => import('./pages/Sobre'));
const Servicos = lazy(() => import('./pages/Servicos'));
const FAQ = lazy(() => import('./pages/FAQ'));

// O painel inteiro fica num chunk separado: quem só visita o
// site nunca baixa esse código. Nenhum componente público pode
// importar de src/admin/ — isso puxaria a árvore toda para o
// bundle principal.
const AdminApp = lazy(() => import('./admin/AdminApp'));

/**
 * Conteúdo do site. Precisa ser um componente separado porque
 * useLocation() só funciona dentro do BrowserRouter.
 */
function Site() {
  // Navbar, botão do WhatsApp e as decorações de fundo ficam
  // fora do <Routes>, então apareceriam por cima do painel.
  const noAdmin = useLocation().pathname.startsWith('/admin');

  if (noAdmin) {
    return (
      <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </Suspense>
    );
  }

  return (
    <>
      <div className="bg-orbs" aria-hidden="true">
        <div className="orb orb-2" />
        <div className="orb orb-3" />
      </div>
      <div className="grain" aria-hidden="true" />

      <Navbar />
      <WhatsAppButton />
      <BackToTop />

      <Suspense fallback={<div style={{ minHeight: '60vh' }} />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicos" element={<Servicos />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Site />
    </BrowserRouter>
  );
}
